import { useLayoutEffect, useState } from "react";

export default function useMatchedElementHeight(containerRef, selector, enabled = true) {
  const [height, setHeight] = useState(null);

  useLayoutEffect(() => {
    if (!enabled || !containerRef.current) return undefined;

    let resizeObserver;
    let mutationObserver;
    let observedTarget = null;

    const findTarget = () => containerRef.current?.querySelector(selector) || null;

    const attachResizeObserver = (target) => {
      if (!target || observedTarget === target) return;
      resizeObserver?.disconnect();
      observedTarget = target;
      resizeObserver = new ResizeObserver(updateHeight);
      resizeObserver.observe(target);
    };

    const updateHeight = () => {
      const target = findTarget();
      if (!target) return;
      attachResizeObserver(target);
      const nextHeight = Math.round(target.getBoundingClientRect().height);
      if (Number.isFinite(nextHeight) && nextHeight > 0) {
        setHeight(nextHeight);
      }
    };

    updateHeight();

    mutationObserver = new MutationObserver(updateHeight);
    mutationObserver.observe(containerRef.current, {
      childList: true,
      subtree: true,
    });

    window.addEventListener("resize", updateHeight);

    return () => {
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      window.removeEventListener("resize", updateHeight);
    };
  }, [containerRef, selector, enabled]);

  return height;
}
